"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _containers = require("./containers");
Object.keys(_containers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _containers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _containers[key];
    }
  });
});
